import './styles/App.scss'
import { Switch, Route} from 'react-router-dom'
//import components
import Home from './components/Home'
import Movie from './components/SingleMovie'

export default function App(){
    return(
            <Switch>
            <Route path="/" exact>
               <Home/> 
            </Route>
            <Route path="/movies/:id" children={<Movie/>} />
            </Switch>
    )
}